export default __webpack_public_path__ + "static/media/delete.e5fd5f2e.svg";